module.exports = __webpack_public_path__ + "static/media/LinkAccount.cc24da7a.svg";